// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2lGuS","disabled":"FileBtn_disabled__1ix8a","warn":"FileBtn_warn__2V9_U","fade":"FileBtn_fade__3Ts-p"};